// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { DocumentFile } from '@shared/data-access/types/engine-types';

export const sumDocumentFilesSize = (
  files: readonly Pick<DocumentFile, 'file_size'>[],
): number => files.reduce((total, file) => total + file.file_size, 0);

export const openDocumentFileInNewTab = (url: string): void => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

const triggerFileDownload = (url: string, fileName: string): void => {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.rel = 'noopener noreferrer';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};

export const downloadDocumentFile = (url: string, fileName: string): void => {
  triggerFileDownload(url, fileName);
};

export const downloadAllDocumentFiles = (files: readonly DocumentFile[]): void => {
  for (const file of files) {
    triggerFileDownload(file.url, file.file_name);
  }
};
